import Vue from "vue";
import VueRouter from "vue-router";

import { Role } from "@/_helpers";
import LoginPage from "@/components/LoginPage";
import MainPage from "@/components/admin/MainPage";
import About from "@/components/parts/About";
import BoardAdmin from "@/components/boards/BoardAdmin";
import BoardModerator from "@/components/boards/BoardModerator";
import BoardUser from "@/components/boards/BoardUser";
import Entrances from "@/components/admin/Entrances";
import Employees from "@/components/admin/Employees";
import DailyPresence from "@/components/admin/DailyPresence";
import DailyPresenceWithFilter from "@/components/admin/DailyPresenceWithFilter";
import Departments from "@/components/admin/Departments";
import Cards from "@/components/admin/Cards";
import Vehicles from "@/components/admin/Vehicles";
import EmployeesView from "@/components/admin/EmployeesView";
import Reports from "@/components/admin/Reports";
import Shifts from "@/components/admin/Shifts";
import Users from "@/components/admin/Users";

import LateList from "@/components/admin/LateList";
import LateListSumm from "@/components/admin/LateListSumm";
import MonthlyPresence from "@/components/admin/MonthlyPresence";
import MonthlyStatus from "@/components/admin/MonthlyStatus";
import Overtime from "@/components/admin/Overtime";
import Obustave from "@/components/admin/Obustave";
import TijanasReport from "@/components/admin/TijanasReport";
import Totaltime from "@/components/admin/Totaltime";
import YeaelyStatus from "@/components/admin/YearlyStatus";
import Absence from "@/components/admin/Absence";
import AbsenceList from "@/components/admin/AbsenceList";
import Toures from "@/components/admin/Routes";
import RouteReport from "@/components/admin/RouteReport";
import RouteReportMonth from "@/components/admin/RouteReportMonth";
import RouteReportDetail from "@/components/admin/RouteReportDetail";
import RouteReportSimple from "@/components/admin/RouteReportSimple";
import ManualFix from "@/components/admin/ManualFix";
import EditEmployeeFull from "@/components/admin/EditEmployeeFull";
import RemoteAccess from "@/components/admin/RemoteAccess";
import AbsenceListAll from "@/components/admin/AbsenceListAll";
import SaturdayShifts from "@/components/admin/SaturdayShifts";
// specials
import Milan from "@/components/admin/special/Milan";
import StadionTatjana01 from "@/components/admin/special/StadionTatjana01";
import StadionTatjana02 from "@/components/admin/special/StadionTatjana02";
import Inconsistences from "@/components/parts/Inconsistences";
import VehicleDetails from "@/components/admin/VehicleDetails";

import Test from "@/components/admin/special/Test";

import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "Home",
    component: LoginPage,
  },
  // {
  //   path: "/logindd",
  //   name: "Home",
  //   component: LoginPage,
  //   // meta: { authorize: [] },
  // },
  {
    path: "/",
    component: MainPage,
    meta: { authorize: [Role.User, Role.Admin, Role.Moderator] },
    // beforeEnter(to, from, next) {
    //   // redirect to login page if not logged in and trying to access a restricted page
    //   if (store.state.authentication.status.loggedIn) {
    //     next();
    //   } else {
    //     next("/login");
    //   }
    // },
    children: [
      {
        path: "admin",
        component: BoardAdmin,
        meta: { authorize: [Role.Admin] },
      },
      {
        path: "moderator",
        component: BoardModerator,
        meta: { authorize: [Role.Moderator] },
      },
      {
        path: "user",
        component: BoardUser,
        meta: { authorize: [Role.User, Role.Moderator] },
        children: [
          {
            path: "entrances",
            component: Entrances,
          },
          {
            path: "reports",
            component: Reports,
          },
          {
            path: "employees",
            component: Employees,
          },
          {
            path: "dailyPresence",
            component: DailyPresence,
          },
          {
            path: "dailyPresencewithfilter",
            component: DailyPresenceWithFilter,
          },
          {
            path: "departments",
            component: Departments,
          },
          {
            path: "cards",
            component: Cards,
          },
          {
            path: "vehicles",
            component: Vehicles,
          },
          {
            path: "employeesView",
            component: EmployeesView,
          },
          {
            path: "shifts",
            component: Shifts,
          },
          {
            path: "users",
            component: Users,
          },
          {
            path: "latelist",
            component: LateList,
          },
          {
            path: "latelistsumm",
            component: LateListSumm,
          },
          {
            path: "monthlypresence",
            component: MonthlyPresence,
          },
          {
            path: "monthlystatus",
            component: MonthlyStatus,
          },
          {
            path: "overtime",
            component: Overtime,
          },
          {
            path: "obustave",
            component: Obustave,
          },
          {
            path: "TijanasReport",
            component: TijanasReport,
          },
          {
            path: "totaltime",
            component: Totaltime,
          },
          {
            path: "yearlystatus",
            component: YeaelyStatus,
          },
          {
            path: "absence",
            component: Absence,
          },
          {
            path: "absencelist",
            component: AbsenceList,
          },
          {
            path: "absencelistall",
            component: AbsenceListAll,
          },
          {
            path: "saturdayshifts",
            component: SaturdayShifts,
          },
          {
            path: "tours",
            component: Toures,
          },
          {
            path: "routereport",
            component: RouteReport,
          },
          {
            path: "routereportmonth",
            component: RouteReportMonth,
          },
          {
            path: "routereportdetail",
            component: RouteReportDetail,
          },
          {
            path: "routereportsimple",
            component: RouteReportSimple,
          },
          {
            path: "manualfix",
            component: ManualFix,
          },
          {
            path: "editemployeefull",
            component: EditEmployeeFull,
          },
          {
            path: "inconsistences",
            component: Inconsistences,
          },
          {
            path: "vehicledetails",
            component: VehicleDetails,
          },
          {
            path: "remoteaccess",
            component: RemoteAccess,
          },
          {
            path: "milan",
            component: Milan,
          },
          {
            path: "test",
            component: Test,
          },
          {
            path: "stadiontatjana01",
            component: StadionTatjana01,
          },
          {
            path: "stadiontatjana02",
            component: StadionTatjana02,
          },
          {
            path: "about",
            component: About,
          },
        ],
      },
    ],
  },

  // Otherwise redirect to home
  { path: "*", redirect: "/" },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const { authorize } = to.meta;
  let currentUser = null;
  if (store.state.auth.user !== undefined) {
    currentUser = store.state.auth.user;
  }

  if (authorize) {
    if (!currentUser) {
      console.log("there is no current user?");
      // not logged in so redirect to login page
      return next("/login");
    }

    // check if route is restricted by role
    if (authorize.length && !authorize.includes(currentUser.role)) {
      // role not authorised so redirect to home page
      return next({ path: "/login" });
    }
  }

  next();

  // const publicPages = ["/login"];
  // const authRequired = !publicPages.includes(to.path);
  // const loggedIn = localStorage.getItem("user");

  // if (authRequired && !loggedIn) {
  //   return next("/login");
  // }

  // next();
});

export default router;
